/**
 * @generated SignedSource<<95b491d07729a26b440adccda686b198>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type CefrLevel = "A1" | "A2" | "B1" | "B2" | "C1" | "C2" | "PRE_A1" | "%future added value";
export type UpdateLearnerInput = {
  cefrLevel?: CefrLevel | null | undefined;
  displayName: string;
  nativeLanguage?: string | null | undefined;
  previousCefrLevel?: CefrLevel | null | undefined;
};
export type AccountProfileUpdateMutation$variables = {
  input: UpdateLearnerInput;
};
export type AccountProfileUpdateMutation$data = {
  readonly updateLearner: {
    readonly learner: {
      readonly cefrLevel: CefrLevel;
      readonly displayName: string;
      readonly id: string;
      readonly interfaceLocale: string;
      readonly nativeLanguage: string | null | undefined;
    } | null | undefined;
  };
};
export type AccountProfileUpdateMutation = {
  response: AccountProfileUpdateMutation$data;
  variables: AccountProfileUpdateMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "UpdateLearnerPayload",
    "kind": "LinkedField",
    "name": "updateLearner",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Learner",
        "kind": "LinkedField",
        "name": "learner",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "displayName",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "nativeLanguage",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "cefrLevel",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "interfaceLocale",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "AccountProfileUpdateMutation",
    "selections": (v1/*:: as any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "AccountProfileUpdateMutation",
    "selections": (v1/*:: as any*/)
  },
  "params": {
    "cacheID": "9396f603074d361ac763176f88b8d451",
    "id": null,
    "metadata": {},
    "name": "AccountProfileUpdateMutation",
    "operationKind": "mutation",
    "text": "mutation AccountProfileUpdateMutation(\n  $input: UpdateLearnerInput!\n) {\n  updateLearner(input: $input) {\n    learner {\n      id\n      displayName\n      nativeLanguage\n      cefrLevel\n      interfaceLocale\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "11263b7138282d92b9b8a59aa2ec1d4c";

export default node;
